import { createFileRoute } from '@tanstack/react-router'
import AdminContainer from 'Admin/containers/AdminContainer'

export const Route = createFileRoute('/admin')({
    component: AdminContainer,
})
